import { POLICY_COVER_PRODUCTS } from "./products";

export const RISK_ITEM_TYPES = {
    PortablePossessions: {
        Id: 1, Image: 'portable-possessions', Name: 'Portable possessions', Product: POLICY_COVER_PRODUCTS.PortablePossessions,
    },
    Caravans: {
        Id: 2, Image: 'caravan', Name: 'Caravan', Product: POLICY_COVER_PRODUCTS.Caravan,
    },
    Trailers: {
        Id: 3, Image: 'trailer', Name: 'Trailer', Product: POLICY_COVER_PRODUCTS.Trailer,
    },
    HomeContents: {
        Id: 4, Image: 'home-content', Name: 'Home contents', Product: POLICY_COVER_PRODUCTS.Content,
    },
    Buildings: {
        Id: 5, Image: 'building', Name: 'Buildings', Product: POLICY_COVER_PRODUCTS.Building,
    },
    Cars: {
        Id: 6, Image: 'car', Name: 'Car', Product: POLICY_COVER_PRODUCTS.Car,
    },
    Motorbikes: {
        Id: 7, Image: 'motorbike', Name: 'Motorbike', Product: POLICY_COVER_PRODUCTS.Motorbike,
    },
    Watercraft: {
        Id: 8, Image: 'watercraft', Name: 'Watercraft', Product: POLICY_COVER_PRODUCTS.Watercraft,
    },
    Cyber: {
        Id: 9, Image: 'cyber', Name: 'Cyber', Product: POLICY_COVER_PRODUCTS.Other,
    },
    Warranty: {
        Id: 10, Image: 'warranty', Name: 'Car warranty', Product: POLICY_COVER_PRODUCTS.Warranty,
    },
    PersonalAccident: {
        Id: 11, Image: 'personal-accident', Name: 'Personal accident', Product: POLICY_COVER_PRODUCTS.PersonalAccident,
    },
    EmergencyService: {
        Id: 12, Image: 'emergency-assist', Name: 'Code red', Product: POLICY_COVER_PRODUCTS.Other,
    },
    Pet: {
        Id: 13, Image: 'pet', Name: 'Pet', Product: POLICY_COVER_PRODUCTS.Other,
    },
    AccidentInsurance: {
        Id: 14, Image: 'personal-accident', Name: 'Personal accident', Product: POLICY_COVER_PRODUCTS.PersonalAccident,
    },
};